"use strict";

var _defineProperty = require("/agent/_work/1/s/node_modules/@babel/runtime/helpers/defineProperty.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var loading_actions_1 = require("./loading.actions");
exports.LOADED = "LOADED";
exports.LOADING = "LOADING";
function loadingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case loading_actions_1.LoadingClearActionType:
      delete state[action.key];
      return Object.assign({}, state);
    case loading_actions_1.LoadingStartActionType:
      return Object.assign(Object.assign({}, state), _defineProperty({}, action.key, exports.LOADING));
    case loading_actions_1.LoadingSuccessActionType:
      return Object.assign(Object.assign({}, state), _defineProperty({}, action.key, exports.LOADED));
    case loading_actions_1.LoadingFailActionType:
      return Object.assign(Object.assign({}, state), _defineProperty({}, action.key, action.error));
    default:
      return state;
  }
}
exports.loadingReducer = loadingReducer;